// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Descriptions, Descriptions.Item */
.ant-layout-header{ 
  background: var(--color-qmir-navy) !important;
}
.ant-descriptions-row {
  /* height: 55px; */
  height: 41px;
  vertical-align: middle;
}
.ant-descriptions-item-label {
  background-color: var(--color-gray01) !important;
  vertical-align: middle;
}
.ant-descriptions-item-label > span {
  display: block;
  text-align: center;
  color: rgba(0, 0, 0, 0.88);
  font-weight: 600;
}
.leftAlign .ant-descriptions-item-label > span {
  display: block;
  text-align: left;
}
.ant-descriptions-item-content {
  text-align: center;
}
.ant-descriptions .ant-descriptions-view {
  border: 1px solid var(--color-gray10) !important;
  border-radius: 0px;
}
.ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view {
  border: 1px solid var(--color-gray10);
  border-bottom: 1px solid transparent !important;
  
}
.ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row {
  border-bottom: 1px solid var(--color-gray10) !important;
  height: 41px;
}
.ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row >.ant-descriptions-item-label {
  border-inline-end: 1px solid var(--color-gray10);
  padding: 4px;
}
.ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row >.ant-descriptions-item-content {
  border-inline-end: 1px solid var(--color-gray10);
  padding: 4px;
  font-size: 1.2rem;
  line-height: 3rem;
  height: 41px;
}
/* 메뉴 */
.ant-menu-light .ant-menu-submenu-selected >.ant-menu-submenu-title, 
.ant-menu-light>.ant-menu .ant-menu-submenu-selected >.ant-menu-submenu-title {
  color: var(--color-qmir-navy);
}
.ant-menu-light .ant-menu-item-selected {
  color: var(--color-qmir-navy);
}
/* 라디오버튼 */
.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
    border-color: var(--color-qmir-navy);
    background-color:var(--color-qmir-navy);
  }
.ant-radio-wrapper:hover .ant-radio-inner {
    border-color: var(--color-qmir-navy);
  }
  /* 인풋박스포커스 */
.ant-input-outlined:focus, 
.ant-input-outlined:focus-within {
    border-color: var(--color-qmir-navy);
  }
  /* 달력인풋박스 */
.ant-picker-outlined:hover {
    border-color: var(--color-qmir-navy);
    background-color: #ffffff;
}
.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected:not(.ant-picker-cell-disabled) .ant-picker-cell-inner, 
.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-disabled) .ant-picker-cell-inner, 
.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-disabled) .ant-picker-cell-inner {
    color: #fff;
    background: var(--color-qmir-navy);
}
  /* 체크 */
.ant-checkbox-checked .ant-checkbox-inner {
  border-color: var(--color-qmir-navy);
  background-color:var(--color-qmir-navy);
}
.ant-checkbox-indeterminate .ant-checkbox-inner:after {
  background-color:var(--color-qmir-navy);
}
/* 페이징 */
.ant-pagination .ant-pagination-item-active {
  border-color: var(--color-qmir-navy);
   a {
    color: var(--color-qmir-navy);
  }
}
/* 셀렉트박스 */
.ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {
    border-color: var(--color-qmir-navy);
} 
/* 트리체크 */
.ant-tree .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner:after {
  background-color:var(--color-qmir-navy); 
}
.ant-tree .ant-tree-checkbox-checked .ant-tree-checkbox-inner {
  border-color: var(--color-qmir-navy);
  background-color:var(--color-qmir-navy);
}
.ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {
  color: var(--color-qmir-navy);;
  border-color: var(--color-qmir-navy);
}
/* 스탭 */
.ant-steps .ant-steps-item-process .ant-steps-item-icon >.ant-steps-icon .ant-steps-icon-dot {
  background: var(--color-qmir-navy);
}
/* 검색영역 */
.search-box {
  display: flex;
  flex-direction: column;
  gap: 7px;

  .stats-wrap {
    color: rgba(0, 0, 0, 0.45);
  }
  .ant-descriptions-header {
    margin-bottom:0px;
  }
  .ant-descriptions-row {
    /* height: 55px; */
    height: 34px;
    vertical-align: middle;
  }
  .ant-descriptions-item-label {
    background-color: transparent !important;
    vertical-align: middle;
  }
  .ant-descriptions-item-label > span {
    display: block;
    text-align: left;
    color: rgba(0, 0, 0, 0.88);
    font-weight: 400;
  }
  .leftAlign .ant-descriptions-item-label > span {
    display: block;
    text-align: left;
  }
  .ant-descriptions-item-content {
    text-align: left;
  }
  .ant-descriptions .ant-descriptions-view {
    border: none !important;
    /* border: 1px solid var(--color-gray10) !important; */
    border-radius: 0px;
  }
  .ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view {
    border: 1px solid var(--color-gray10);
    border-bottom: none !important;
    
  }
  .ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row {
    border-bottom: none !important;
    height: 34px;
  }
  .ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row >.ant-descriptions-item-label {
    border-inline-end: none;
    padding: 0px 7px 0px 0px;
  }
  .ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row >.ant-descriptions-item-content {
    border-inline-end: none;
    padding: 0px 15px 0px 0px;
    vertical-align: middle;
    font-size: 1rem;
    line-height: 1rem;
    height: 34px;
    &:last-child {
      padding-right: 0px;
    }
  }
}


/* Table Cell */
.ant-table-cell  {
  border-radius: 0px !important;;
}
.ant-table-thead > tr > th {
  height: 41px;
  /* background-color: var(--color-gray01) !important; */
  vertical-align: middle;
}
.ant-table-tbody > .ant-table-row {
  height: 41px;
  /* height: 55px; */
}
.ant-table-tbody > .ant-table-row > .ant-table-cell {
  font-size: 1.1rem;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
  &.table-background-red {
    background-color: var(--color-qmir-orange)
  }
}
.ant-table-wrapper .ant-table-thead >tr>th::not(:first-child) { 
  background-color: var(--color-gray01) !important;
  border-bottom: none;
  /* border-bottom: 1px solid var(--color-gray10); */
  border-top: 1px solid var(--color-gray10);
}
.ant-table-wrapper .ant-table-thead >tr:first-child>th  {
  border-bottom: 1px solid var(--color-gray10);

}
.ant-table-wrapper .ant-table-thead >tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  background-color: var(--color-gray10);
  height: 2rem;
}
.ant-table-wrapper .ant-table-tbody >tr >td  {
  border-bottom: 1px solid  var(--color-gray10);;
}
.ant-table-wrapper .ant-table-tbody >tr:first-child >td {
  border-top:1px solid var(--color-gray10);
}
.ant-table-wrapper .ant-table.ant-table-small .ant-table-tbody>tr>td {
  padding: 4px 7px;
}
.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-header >table >thead >tr:not(:last-child)>th,
.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-content >table >thead >tr:not(:last-child)>th {
  border-bottom: 1px solid var(--color-gray10);
}
.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-content >table >thead>tr>td { 
  border-inline-end: 1px solid var(--color-gray10);
  border-bottom:1px solid var(--color-gray10);
}

.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-header >table >thead>tr>th,
.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-content >table >thead >tr>th {
  border-bottom: 1px solid var(--color-gray10);
}
.ant-table-wrapper .ant-table >.ant-table-container { border-bottom: none;}

.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container {
  border-inline-start: 1px solid var(--color-gray10);
  
  >.ant-table-content >table >tbody>tr>td {
    /* border-inline-start: 1px solid var(--color-gray10); */
    border-inline-end: 1px solid var(--color-gray10);
  }
  >.ant-table-header >table >thead>tr>th,
  >.ant-table-content >table >thead>tr>th {
    border-inline-end: 1px solid var(--color-gray10);
  }
  
  >.ant-table-body >table >tbody>tr>td {
    border-inline-end: 1px solid var(--color-gray10);
  }




}
.ant-table-wrapper .ant-table-summary >tr >td {
  border-bottom: 1px solid var(--color-gray10);
}
.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-content >table >tfoot>tr>td {
  border-inline-end: 1px solid var(--color-gray10);
}
.ant-table-wrapper.bordered .ant-table-thead >tr>th { 
  border-inline-end: 1px solid var(--color-gray10);
}
.ant-table-wrapper.bordered .ant-table-thead >tr>th:last-child { 
  border-inline-end: none;
}
.ant-table-wrapper.bordered .ant-table-tbody >tr>td:last-child {
  border-inline-end: none;
}
.ant-table-wrapper.bordered .ant-table-tbody > .ant-table-row > .ant-table-cell {
  border-inline-end: 1px solid var(--color-gray10);
}
.ant-table-wrapper.bordered .ant-table-tbody > .ant-table-row > .ant-table-cell:last-child {
  /* border-inline-end: none; */
}
.ant-table-wrapper.bordered .ant-table-thead >tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  background-color: none;
}

.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container {
  /* border-top: none; */
  border-top: 1px solid var(--color-gray10);
}

.second-table  .ant-table-wrapper .ant-table-thead >tr>th {
  background-color: var(--color-gray01) !important;
  min-width: 82px;
}

.ant-table {
  table > thead > tr > th.ant-table-cell::before {
    background-color: var(--color-gray10) !important;
  }
}
/* table children +버튼 숨기기 */
.ant-table-wrapper .ant-table-row-expand-icon {
  display: none;
}


.ant-select-single:not(.ant-select-customize-input) {
  font-size: 1.2rem;
  height: 28.84px;
}

.ant-select-selector {
  /* height: 32px !important; */
}
.ant-tabs-nav {
  background-color: #ffffff;
  height: 34px;
  margin: 0px !important;
  padding-left: 24px;
}
.ant-tabs-tab > .ant-tabs-tab-btn {
  font-size: 1.5rem !important;
  color: rgba(0, 0, 0, 0.45) !important;
}
.ant-tabs-tab-active > .ant-tabs-tab-btn {
  font-size: 1.5rem !important;
  color: rgba(0, 0, 0) !important;
}
/* InputNumber */
.ant-input-number-input-wrap > input.ant-input-number-input {
  text-align: left;
}
.ant-picker .ant-picker-input >input {
  font-size: 1.2rem;
}

/* Carousel Dot */
.ant-carousel {
  margin-bottom: 15px;
}
.slick-dots > li > button {
  
  


  height: 0.75rem !important;
  border-radius: 0.35rem !important;
}
.slick-dots-bottom {
  /* bottom: -12px !important; */
  position: unset !important;
}

/* 탭 */
.ant-tabs-content-top:first-child {
  /* margin-top: 14px; */
}

/* btn */
.ant-btn {
  /* height: 28px; */
  &.active_false {
    color: var(--color-gray03);
    border-color: var(--color-gray03);
  }
  &.active_true {
    color: #ffffff;
    background-color:var(--color-gray03);
  }
}
.ant-btn-default {
  box-shadow:none;
}
.ant-btn-icon {
  margin-inline-end: 3px !important;
}


/* pdf  */
.rpv-core__viewer {
  .rpv-core__inner-page-container > div {
    display: none;
    &[aria-label='Page 1'] {
      display: block;
      .rpv-core__page-layer {
        margin: 0px auto;
      }
    }
    
  }
  .rpv-core__inner-pages {
    overflow: hidden;
    .rpv-core__inner-page {
      background-color: transparent;
      /* width: 160px; */
      /* left: calc(-50% + 110px) !important; */
      
    }
  }
}
.rpv-core__modal_viewer {
  .rpv-core__inner-page-container > div  {
    display: block;
  }
  .rpv-core__inner-pages {
    overflow: auto;
  }
}

/* modal */
.bord-class-pdf-modal > div[tabindex="-1"] {
  height: 100%;
}




/* card */
.ant-card.bg-gray .ant-card-body {
  background-color: #525659;
}
.ant-card-small.bg-gray {
  &.non-display {
    background-color:#525659;
    >.ant-card-head {
      color:#fff;
    }
  }
  >.ant-card-head {
  width : 175px;
    .ant-space-item {
      width : 135px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    
    }
  }
}
  

/* Calendar */
.ant-picker-content tbody {
  border-left: 1px solid var(--color-gray10);
  border-top: 1px solid var(--color-gray10);
}
.ant-picker-cell {
  border-right: 1px solid var(--color-gray10);
  border-bottom: 1px solid var(--color-gray10);
}
.ant-picker-calendar-date {
  border-top: 0 !important;
  margin: 0 !important;
  padding: 4px 0 15px 0 !important;
}
.ant-picker-calendar-date-value {
  padding: 0 12px;
}
.ant-picker-calendar-date-content {
  height: auto !important;
  min-height: 86px;
  overflow-y: unset !important;

.ant-badge-status-text a {
    font-size: 1.2rem !important;
  }
}



/* sider */
.side-container {
  .ant-layout-sider-children ul.ant-menu-inline.ant-menu-root {
    > li.ant-menu-item {
      padding-left: 4px !important;
    }
    .ant-menu-submenu-title {
      padding-left: 4px !important;
      
    }
    li li.ant-menu-item {
      padding-left: 28px !important;
    }
  }

}

/* .ant-checkbox-group  */
.ant-checkbox-group {
  column-gap: 4px;
}


.ant-anchor-wrapper {
  background: #fff;
}


.fc .fc-button {
  border-radius: 4px;
  height: 28px;
  padding: 4px 12px;
  .fc-icon {
    font-size: 1.2rem;
  }
}
.fc .fc-button-group > .fc-button {
  font-size: 1.2rem;
  line-height: 1.2rem;
  background-color: #fff;
  color: var(--color-gray03);
  padding: 0px 8px;
}

.fc-event-time {
  display: none;
}


.ant-col-1 {
  max-width:4rem;
}

.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-content >table >tbody>tr>td >.ant-table-expanded-row-fixed::after {
  border-inline-end : none;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/antd-override.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,+CAA+C;;AAEjD;AACA;EACE,uDAAuD;EACvD,YAAY;AACd;AACA;EACE,gDAAgD;EAChD,YAAY;AACd;AACA;EACE,gDAAgD;EAChD,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;AACA,OAAO;AACP;;EAEE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA,UAAU;AACV;IACI,oCAAoC;IACpC,uCAAuC;EACzC;AACF;IACI,oCAAoC;EACtC;EACA,YAAY;AACd;;IAEI,oCAAoC;EACtC;EACA,WAAW;AACb;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;;;IAGI,WAAW;IACX,kCAAkC;AACtC;EACE,OAAO;AACT;EACE,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA,QAAQ;AACR;EACE,oCAAoC;GACnC;IACC,6BAA6B;EAC/B;AACF;AACA,UAAU;AACV;IACI,oCAAoC;AACxC;AACA,SAAS;AACT;EACE,uCAAuC;AACzC;AACA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;AACA,OAAO;AACP;EACE,kCAAkC;AACpC;AACA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,wCAAwC;IACxC,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,sDAAsD;IACtD,kBAAkB;EACpB;EACA;IACE,qCAAqC;IACrC,8BAA8B;;EAEhC;EACA;IACE,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ;MACE,kBAAkB;IACpB;EACF;AACF;;;AAGA,eAAe;AACf;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,sDAAsD;EACtD,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;EACjC;IACE;EACF;AACF;AACA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,kDAAkD;EAClD,yCAAyC;AAC3C;AACA;EACE,4CAA4C;;AAE9C;AACA;EACE,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,gDAAgD;EAChD,2CAA2C;AAC7C;;AAEA;;EAEE,4CAA4C;AAC9C;AACA,sDAAsD,mBAAmB,CAAC;;AAE1E;EACE,kDAAkD;;EAElD;IACE,wDAAwD;IACxD,gDAAgD;EAClD;EACA;;IAEE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;;;;AAKF;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;AACA,2BAA2B;AAC3B;EACE,aAAa;AACf;;;AAGA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,qCAAqC;AACvC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;AACA;;;;;EAKE,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,MAAM;AACN;EACE,sBAAsB;AACxB;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;EACA;IACE,cAAc;IACd,oCAAoC;EACtC;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;;;AAGA,SAAS;AACT;EACE;IACE,aAAa;IACb;MACE,cAAc;MACd;QACE,gBAAgB;MAClB;IACF;;EAEF;EACA;IACE,gBAAgB;IAChB;MACE,6BAA6B;MAC7B,kBAAkB;MAClB,yCAAyC;;IAE3C;EACF;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;;AAEA,UAAU;AACV;EACE,YAAY;AACd;;;;;AAKA,SAAS;AACT;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,wBAAwB;IACxB;MACE,UAAU;IACZ;EACF;EACA;EACA,aAAa;IACX;MACE,aAAa;MACb,eAAe;MACf,sBAAsB;MACtB,kBAAkB;;IAEpB;EACF;AACF;;;AAGA,aAAa;AACb;EACE,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;;AAE9B;IACI,4BAA4B;EAC9B;AACF;;;;AAIA,UAAU;AACV;EACE;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,4BAA4B;;IAE9B;IACA;MACE,6BAA6B;IAC/B;EACF;;AAEF;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;;;AAGA;EACE,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB;IACE,iBAAiB;EACnB;AACF;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* Descriptions, Descriptions.Item */\r\n.ant-layout-header{ \r\n  background: var(--color-qmir-navy) !important;\r\n}\r\n.ant-descriptions-row {\r\n  /* height: 55px; */\r\n  height: 41px;\r\n  vertical-align: middle;\r\n}\r\n.ant-descriptions-item-label {\r\n  background-color: var(--color-gray01) !important;\r\n  vertical-align: middle;\r\n}\r\n.ant-descriptions-item-label > span {\r\n  display: block;\r\n  text-align: center;\r\n  color: rgba(0, 0, 0, 0.88);\r\n  font-weight: 600;\r\n}\r\n.leftAlign .ant-descriptions-item-label > span {\r\n  display: block;\r\n  text-align: left;\r\n}\r\n.ant-descriptions-item-content {\r\n  text-align: center;\r\n}\r\n.ant-descriptions .ant-descriptions-view {\r\n  border: 1px solid var(--color-gray10) !important;\r\n  border-radius: 0px;\r\n}\r\n.ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view {\r\n  border: 1px solid var(--color-gray10);\r\n  border-bottom: 1px solid transparent !important;\r\n  \r\n}\r\n.ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row {\r\n  border-bottom: 1px solid var(--color-gray10) !important;\r\n  height: 41px;\r\n}\r\n.ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row >.ant-descriptions-item-label {\r\n  border-inline-end: 1px solid var(--color-gray10);\r\n  padding: 4px;\r\n}\r\n.ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row >.ant-descriptions-item-content {\r\n  border-inline-end: 1px solid var(--color-gray10);\r\n  padding: 4px;\r\n  font-size: 1.2rem;\r\n  line-height: 3rem;\r\n  height: 41px;\r\n}\r\n/* 메뉴 */\r\n.ant-menu-light .ant-menu-submenu-selected >.ant-menu-submenu-title, \r\n.ant-menu-light>.ant-menu .ant-menu-submenu-selected >.ant-menu-submenu-title {\r\n  color: var(--color-qmir-navy);\r\n}\r\n.ant-menu-light .ant-menu-item-selected {\r\n  color: var(--color-qmir-navy);\r\n}\r\n/* 라디오버튼 */\r\n.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {\r\n    border-color: var(--color-qmir-navy);\r\n    background-color:var(--color-qmir-navy);\r\n  }\r\n.ant-radio-wrapper:hover .ant-radio-inner {\r\n    border-color: var(--color-qmir-navy);\r\n  }\r\n  /* 인풋박스포커스 */\r\n.ant-input-outlined:focus, \r\n.ant-input-outlined:focus-within {\r\n    border-color: var(--color-qmir-navy);\r\n  }\r\n  /* 달력인풋박스 */\r\n.ant-picker-outlined:hover {\r\n    border-color: var(--color-qmir-navy);\r\n    background-color: #ffffff;\r\n}\r\n.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-selected:not(.ant-picker-cell-disabled) .ant-picker-cell-inner, \r\n.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-disabled) .ant-picker-cell-inner, \r\n.ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-disabled) .ant-picker-cell-inner {\r\n    color: #fff;\r\n    background: var(--color-qmir-navy);\r\n}\r\n  /* 체크 */\r\n.ant-checkbox-checked .ant-checkbox-inner {\r\n  border-color: var(--color-qmir-navy);\r\n  background-color:var(--color-qmir-navy);\r\n}\r\n.ant-checkbox-indeterminate .ant-checkbox-inner:after {\r\n  background-color:var(--color-qmir-navy);\r\n}\r\n/* 페이징 */\r\n.ant-pagination .ant-pagination-item-active {\r\n  border-color: var(--color-qmir-navy);\r\n   a {\r\n    color: var(--color-qmir-navy);\r\n  }\r\n}\r\n/* 셀렉트박스 */\r\n.ant-select-outlined:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {\r\n    border-color: var(--color-qmir-navy);\r\n} \r\n/* 트리체크 */\r\n.ant-tree .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner:after {\r\n  background-color:var(--color-qmir-navy); \r\n}\r\n.ant-tree .ant-tree-checkbox-checked .ant-tree-checkbox-inner {\r\n  border-color: var(--color-qmir-navy);\r\n  background-color:var(--color-qmir-navy);\r\n}\r\n.ant-btn-default:not(:disabled):not(.ant-btn-disabled):hover {\r\n  color: var(--color-qmir-navy);;\r\n  border-color: var(--color-qmir-navy);\r\n}\r\n/* 스탭 */\r\n.ant-steps .ant-steps-item-process .ant-steps-item-icon >.ant-steps-icon .ant-steps-icon-dot {\r\n  background: var(--color-qmir-navy);\r\n}\r\n/* 검색영역 */\r\n.search-box {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 7px;\r\n\r\n  .stats-wrap {\r\n    color: rgba(0, 0, 0, 0.45);\r\n  }\r\n  .ant-descriptions-header {\r\n    margin-bottom:0px;\r\n  }\r\n  .ant-descriptions-row {\r\n    /* height: 55px; */\r\n    height: 34px;\r\n    vertical-align: middle;\r\n  }\r\n  .ant-descriptions-item-label {\r\n    background-color: transparent !important;\r\n    vertical-align: middle;\r\n  }\r\n  .ant-descriptions-item-label > span {\r\n    display: block;\r\n    text-align: left;\r\n    color: rgba(0, 0, 0, 0.88);\r\n    font-weight: 400;\r\n  }\r\n  .leftAlign .ant-descriptions-item-label > span {\r\n    display: block;\r\n    text-align: left;\r\n  }\r\n  .ant-descriptions-item-content {\r\n    text-align: left;\r\n  }\r\n  .ant-descriptions .ant-descriptions-view {\r\n    border: none !important;\r\n    /* border: 1px solid var(--color-gray10) !important; */\r\n    border-radius: 0px;\r\n  }\r\n  .ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view {\r\n    border: 1px solid var(--color-gray10);\r\n    border-bottom: none !important;\r\n    \r\n  }\r\n  .ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row {\r\n    border-bottom: none !important;\r\n    height: 34px;\r\n  }\r\n  .ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row >.ant-descriptions-item-label {\r\n    border-inline-end: none;\r\n    padding: 0px 7px 0px 0px;\r\n  }\r\n  .ant-descriptions.ant-descriptions-bordered >.ant-descriptions-view .ant-descriptions-row >.ant-descriptions-item-content {\r\n    border-inline-end: none;\r\n    padding: 0px 15px 0px 0px;\r\n    vertical-align: middle;\r\n    font-size: 1rem;\r\n    line-height: 1rem;\r\n    height: 34px;\r\n    &:last-child {\r\n      padding-right: 0px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/* Table Cell */\r\n.ant-table-cell  {\r\n  border-radius: 0px !important;;\r\n}\r\n.ant-table-thead > tr > th {\r\n  height: 41px;\r\n  /* background-color: var(--color-gray01) !important; */\r\n  vertical-align: middle;\r\n}\r\n.ant-table-tbody > .ant-table-row {\r\n  height: 41px;\r\n  /* height: 55px; */\r\n}\r\n.ant-table-tbody > .ant-table-row > .ant-table-cell {\r\n  font-size: 1.1rem;\r\n  font-weight: normal;\r\n  background-color: #ffffff;\r\n  vertical-align: middle !important;\r\n  &.table-background-red {\r\n    background-color: var(--color-qmir-orange)\r\n  }\r\n}\r\n.ant-table-wrapper .ant-table-thead >tr>th::not(:first-child) { \r\n  background-color: var(--color-gray01) !important;\r\n  border-bottom: none;\r\n  /* border-bottom: 1px solid var(--color-gray10); */\r\n  border-top: 1px solid var(--color-gray10);\r\n}\r\n.ant-table-wrapper .ant-table-thead >tr:first-child>th  {\r\n  border-bottom: 1px solid var(--color-gray10);\r\n\r\n}\r\n.ant-table-wrapper .ant-table-thead >tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\r\n  background-color: var(--color-gray10);\r\n  height: 2rem;\r\n}\r\n.ant-table-wrapper .ant-table-tbody >tr >td  {\r\n  border-bottom: 1px solid  var(--color-gray10);;\r\n}\r\n.ant-table-wrapper .ant-table-tbody >tr:first-child >td {\r\n  border-top:1px solid var(--color-gray10);\r\n}\r\n.ant-table-wrapper .ant-table.ant-table-small .ant-table-tbody>tr>td {\r\n  padding: 4px 7px;\r\n}\r\n.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-header >table >thead >tr:not(:last-child)>th,\r\n.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-content >table >thead >tr:not(:last-child)>th {\r\n  border-bottom: 1px solid var(--color-gray10);\r\n}\r\n.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-content >table >thead>tr>td { \r\n  border-inline-end: 1px solid var(--color-gray10);\r\n  border-bottom:1px solid var(--color-gray10);\r\n}\r\n\r\n.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-header >table >thead>tr>th,\r\n.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-content >table >thead >tr>th {\r\n  border-bottom: 1px solid var(--color-gray10);\r\n}\r\n.ant-table-wrapper .ant-table >.ant-table-container { border-bottom: none;}\r\n\r\n.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container {\r\n  border-inline-start: 1px solid var(--color-gray10);\r\n  \r\n  >.ant-table-content >table >tbody>tr>td {\r\n    /* border-inline-start: 1px solid var(--color-gray10); */\r\n    border-inline-end: 1px solid var(--color-gray10);\r\n  }\r\n  >.ant-table-header >table >thead>tr>th,\r\n  >.ant-table-content >table >thead>tr>th {\r\n    border-inline-end: 1px solid var(--color-gray10);\r\n  }\r\n  \r\n  >.ant-table-body >table >tbody>tr>td {\r\n    border-inline-end: 1px solid var(--color-gray10);\r\n  }\r\n\r\n\r\n\r\n\r\n}\r\n.ant-table-wrapper .ant-table-summary >tr >td {\r\n  border-bottom: 1px solid var(--color-gray10);\r\n}\r\n.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-content >table >tfoot>tr>td {\r\n  border-inline-end: 1px solid var(--color-gray10);\r\n}\r\n.ant-table-wrapper.bordered .ant-table-thead >tr>th { \r\n  border-inline-end: 1px solid var(--color-gray10);\r\n}\r\n.ant-table-wrapper.bordered .ant-table-thead >tr>th:last-child { \r\n  border-inline-end: none;\r\n}\r\n.ant-table-wrapper.bordered .ant-table-tbody >tr>td:last-child {\r\n  border-inline-end: none;\r\n}\r\n.ant-table-wrapper.bordered .ant-table-tbody > .ant-table-row > .ant-table-cell {\r\n  border-inline-end: 1px solid var(--color-gray10);\r\n}\r\n.ant-table-wrapper.bordered .ant-table-tbody > .ant-table-row > .ant-table-cell:last-child {\r\n  /* border-inline-end: none; */\r\n}\r\n.ant-table-wrapper.bordered .ant-table-thead >tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\r\n  background-color: none;\r\n}\r\n\r\n.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container {\r\n  /* border-top: none; */\r\n  border-top: 1px solid var(--color-gray10);\r\n}\r\n\r\n.second-table  .ant-table-wrapper .ant-table-thead >tr>th {\r\n  background-color: var(--color-gray01) !important;\r\n  min-width: 82px;\r\n}\r\n\r\n.ant-table {\r\n  table > thead > tr > th.ant-table-cell::before {\r\n    background-color: var(--color-gray10) !important;\r\n  }\r\n}\r\n/* table children +버튼 숨기기 */\r\n.ant-table-wrapper .ant-table-row-expand-icon {\r\n  display: none;\r\n}\r\n\r\n\r\n.ant-select-single:not(.ant-select-customize-input) {\r\n  font-size: 1.2rem;\r\n  height: 28.84px;\r\n}\r\n\r\n.ant-select-selector {\r\n  /* height: 32px !important; */\r\n}\r\n.ant-tabs-nav {\r\n  background-color: #ffffff;\r\n  height: 34px;\r\n  margin: 0px !important;\r\n  padding-left: 24px;\r\n}\r\n.ant-tabs-tab > .ant-tabs-tab-btn {\r\n  font-size: 1.5rem !important;\r\n  color: rgba(0, 0, 0, 0.45) !important;\r\n}\r\n.ant-tabs-tab-active > .ant-tabs-tab-btn {\r\n  font-size: 1.5rem !important;\r\n  color: rgba(0, 0, 0) !important;\r\n}\r\n/* InputNumber */\r\n.ant-input-number-input-wrap > input.ant-input-number-input {\r\n  text-align: left;\r\n}\r\n.ant-picker .ant-picker-input >input {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n/* Carousel Dot */\r\n.ant-carousel {\r\n  margin-bottom: 15px;\r\n}\r\n.slick-dots > li > button {\r\n  \r\n  \r\n\r\n\r\n  height: 0.75rem !important;\r\n  border-radius: 0.35rem !important;\r\n}\r\n.slick-dots-bottom {\r\n  /* bottom: -12px !important; */\r\n  position: unset !important;\r\n}\r\n\r\n/* 탭 */\r\n.ant-tabs-content-top:first-child {\r\n  /* margin-top: 14px; */\r\n}\r\n\r\n/* btn */\r\n.ant-btn {\r\n  /* height: 28px; */\r\n  &.active_false {\r\n    color: var(--color-gray03);\r\n    border-color: var(--color-gray03);\r\n  }\r\n  &.active_true {\r\n    color: #ffffff;\r\n    background-color:var(--color-gray03);\r\n  }\r\n}\r\n.ant-btn-default {\r\n  box-shadow:none;\r\n}\r\n.ant-btn-icon {\r\n  margin-inline-end: 3px !important;\r\n}\r\n\r\n\r\n/* pdf  */\r\n.rpv-core__viewer {\r\n  .rpv-core__inner-page-container > div {\r\n    display: none;\r\n    &[aria-label='Page 1'] {\r\n      display: block;\r\n      .rpv-core__page-layer {\r\n        margin: 0px auto;\r\n      }\r\n    }\r\n    \r\n  }\r\n  .rpv-core__inner-pages {\r\n    overflow: hidden;\r\n    .rpv-core__inner-page {\r\n      background-color: transparent;\r\n      /* width: 160px; */\r\n      /* left: calc(-50% + 110px) !important; */\r\n      \r\n    }\r\n  }\r\n}\r\n.rpv-core__modal_viewer {\r\n  .rpv-core__inner-page-container > div  {\r\n    display: block;\r\n  }\r\n  .rpv-core__inner-pages {\r\n    overflow: auto;\r\n  }\r\n}\r\n\r\n/* modal */\r\n.bord-class-pdf-modal > div[tabindex=\"-1\"] {\r\n  height: 100%;\r\n}\r\n\r\n\r\n\r\n\r\n/* card */\r\n.ant-card.bg-gray .ant-card-body {\r\n  background-color: #525659;\r\n}\r\n.ant-card-small.bg-gray {\r\n  &.non-display {\r\n    background-color:#525659;\r\n    >.ant-card-head {\r\n      color:#fff;\r\n    }\r\n  }\r\n  >.ant-card-head {\r\n  width : 175px;\r\n    .ant-space-item {\r\n      width : 135px;\r\n      overflow:hidden;\r\n      text-overflow:ellipsis;\r\n      white-space:nowrap;\r\n    \r\n    }\r\n  }\r\n}\r\n  \r\n\r\n/* Calendar */\r\n.ant-picker-content tbody {\r\n  border-left: 1px solid var(--color-gray10);\r\n  border-top: 1px solid var(--color-gray10);\r\n}\r\n.ant-picker-cell {\r\n  border-right: 1px solid var(--color-gray10);\r\n  border-bottom: 1px solid var(--color-gray10);\r\n}\r\n.ant-picker-calendar-date {\r\n  border-top: 0 !important;\r\n  margin: 0 !important;\r\n  padding: 4px 0 15px 0 !important;\r\n}\r\n.ant-picker-calendar-date-value {\r\n  padding: 0 12px;\r\n}\r\n.ant-picker-calendar-date-content {\r\n  height: auto !important;\r\n  min-height: 86px;\r\n  overflow-y: unset !important;\r\n\r\n.ant-badge-status-text a {\r\n    font-size: 1.2rem !important;\r\n  }\r\n}\r\n\r\n\r\n\r\n/* sider */\r\n.side-container {\r\n  .ant-layout-sider-children ul.ant-menu-inline.ant-menu-root {\r\n    > li.ant-menu-item {\r\n      padding-left: 4px !important;\r\n    }\r\n    .ant-menu-submenu-title {\r\n      padding-left: 4px !important;\r\n      \r\n    }\r\n    li li.ant-menu-item {\r\n      padding-left: 28px !important;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n/* .ant-checkbox-group  */\r\n.ant-checkbox-group {\r\n  column-gap: 4px;\r\n}\r\n\r\n\r\n.ant-anchor-wrapper {\r\n  background: #fff;\r\n}\r\n\r\n\r\n.fc .fc-button {\r\n  border-radius: 4px;\r\n  height: 28px;\r\n  padding: 4px 12px;\r\n  .fc-icon {\r\n    font-size: 1.2rem;\r\n  }\r\n}\r\n.fc .fc-button-group > .fc-button {\r\n  font-size: 1.2rem;\r\n  line-height: 1.2rem;\r\n  background-color: #fff;\r\n  color: var(--color-gray03);\r\n  padding: 0px 8px;\r\n}\r\n\r\n.fc-event-time {\r\n  display: none;\r\n}\r\n\r\n\r\n.ant-col-1 {\r\n  max-width:4rem;\r\n}\r\n\r\n.ant-table-wrapper .ant-table.ant-table-bordered >.ant-table-container >.ant-table-content >table >tbody>tr>td >.ant-table-expanded-row-fixed::after {\r\n  border-inline-end : none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
